import { render, staticRenderFns } from "./IconTrailer.vue?vue&type=template&id=71a88a78"
import script from "./IconTrailer.vue?vue&type=script&lang=js"
export * from "./IconTrailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports